import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";

import {
  GetServicesByNodeQuery,
  GetServicesByNodeQueryVariables,
  SelectionKey,
  Service,
} from "../../../API";
import { GET_SERVICES_BY_NODE } from "../../../common/operations/queries";
import { errorNotification } from "../../../common/variables/notification";

export const useGetServicesByNode = (nodeId?: string) => {
  useEffect(() => {
    if (nodeId) {
      fetchServicesByNodeFunc(nodeId);
    }
  }, [nodeId]);

  const [getServicesByNode, { data, loading }] = useLazyQuery<
    GetServicesByNodeQuery,
    GetServicesByNodeQueryVariables
  >(GET_SERVICES_BY_NODE);

  const fetchServicesByNodeFunc = async (
    nodeId: string,
    nextToken?: string,
    accumulator: Service[] = []
  ): Promise<Service[]> => {
    try {
      const response = await getServicesByNode({
        variables: {
          nodeId,
          nextToken,
          modelAlertSettingsSelectionKey: SelectionKey.keys,
        },
      });

      const pageItems = (response?.data?.getServicesByNode?.items ??
        []) as Service[];
      const combined = [...accumulator, ...pageItems];

      const token = response?.data?.getServicesByNode?.nextToken;

      if (token) {
        return await fetchServicesByNodeFunc(nodeId, token, combined);
      }

      if (response.error) {
        errorNotification(response.error.message);
      }

      return combined;
    } catch (e) {
      console.error(e);
      const message = e instanceof Error ? e.message : "Unknown error";

      errorNotification(message);

      return accumulator;
    }
  };

  return {
    data,
    loading,
    fetchServicesByNodeFunc,
  };
};
